import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';

const handleStyle = { width: 4, height: 4, borderRadius: '50%', border: '1px solid #fff', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' };
const labelStyle = {
  fontSize: '0.6rem',
  lineHeight: 1.15,
  wordBreak: 'break-word'
};
const baseNode = {
  padding: '4px 6px',
  borderRadius: '4px',
  width: 'fit-content',
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
  border: '1px solid',
  display: 'flex',
  alignItems: 'center',
  gap: 0.5
};

export function StartNode({ data }) {
  return (
    <Box
      sx={{
        ...baseNode,
        bgcolor: '#e8f5e9',
        borderColor: '#a5d6a7',
      }}
    >
      <Handle type="source" position={Position.Bottom} style={{ ...handleStyle, background: '#43a047' }} />
      <PlayArrowRoundedIcon sx={{ fontSize: 8, color: '#2e7d32' }} />
      <Typography variant="caption" fontWeight={600} color="#1b5e20" sx={labelStyle}>
        {data?.label || 'Start'}
      </Typography>
    </Box>
  );
}

export function TaskNode({ data }) {
  return (
    <Box
      sx={{
        ...baseNode,
        bgcolor: '#e3f2fd',
        borderColor: '#90caf9',
      }}
    >
      <Handle type="target" position={Position.Top} style={{ ...handleStyle, background: '#1976d2' }} />
      <Handle type="source" position={Position.Bottom} style={{ ...handleStyle, background: '#1976d2' }} />
      <CodeRoundedIcon sx={{ fontSize: 8, color: '#1565c0' }} />
      <Typography variant="caption" fontWeight={600} color="#0d47a1" sx={labelStyle}>
        {data?.label || 'Task'}
      </Typography>
    </Box>
  );
}

export function EndNode({ data }) {
  return (
    <Box
      sx={{
        ...baseNode,
        bgcolor: '#f5f5f5',
        borderColor: '#bdbdbd',
      }}
    >
      <Handle type="target" position={Position.Top} style={{ ...handleStyle, background: '#757575' }} />
      <FlagRoundedIcon sx={{ fontSize: 8, color: '#616161' }} />
      <Typography variant="caption" fontWeight={600} color="#424242" sx={labelStyle}>
        {data?.label || 'End'}
      </Typography>
    </Box>
  );
}

export const nodeTypes = {
  start: StartNode,
  task: TaskNode,
  end: EndNode,
};
